import { render, staticRenderFns } from "./PricingVerOne.vue?vue&type=template&id=69688421&scoped=true&"
import script from "./PricingVerOne.vue?vue&type=script&lang=js&"
export * from "./PricingVerOne.vue?vue&type=script&lang=js&"
import style0 from "./PricingVerOne.vue?vue&type=style&index=0&id=69688421&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69688421",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VImg,VRow})
